import axios from "axios";

class V1_request {
    options = {
        baseURL: '/api',
        timeout: 1000 * 60,
        headers: {"Content-Type": "application/json"}
    }

    get = axios.create({
        method: 'GET', ...this.options
    });

    post = axios.create({
        method: 'POST', ...this.options
    })

    put = axios.create({
        method: 'PUT', ...this.options
    })

    delete = axios.create({
        method: 'DELETE', ...this.options
    })

    patch = axios.create({
        method: 'PATCH', ...this.options
    })
}

const v1Request = new V1_request();
export const get = v1Request.get
export const post = v1Request.post
export const put = v1Request.put
export const del = v1Request.delete
export const patch = v1Request.patch
